import { login, logout, getInfo } from '@/api/login'
import { getCompany } from '@/api/system/company'
import { getToken, setToken, removeToken } from '@/utils/auth'
import defAva from '@/assets/images/profile.jpg'

const useUserStore = defineStore(
  'user',
  {
    state: () => ({
      token: getToken(),
      userId: '',
      cpid: '',
      name: '',
      avatar: '',
      roles: [],
      permissions: [],
      company: null
    }),
    actions: {
      // 登录
      login(userInfo) {
        const username = userInfo.username.trim()
        const password = userInfo.password
        const code = userInfo.code
        const uuid = userInfo.uuid
        return new Promise((resolve, reject) => {
          login(username, password, code, uuid).then(res => {
            let data = res.data
            setToken(data.access_token)
            this.token = data.access_token
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 获取用户信息
      getInfo() {
        return new Promise((resolve, reject) => {
          getInfo().then(res => {
            const user = res.user
            const avatar = (user.avatar == "" || user.avatar == null) ? defAva : user.avatar;

            if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
              this.roles = res.roles
              this.permissions = res.permissions
            } else {
              this.roles = ['ROLE_DEFAULT']
            }

            this.userId = user.userId
            this.name = user.userName
            this.cpid = user.cpid
            this.avatar = avatar;
            this.getCompanyInfo();
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 获取公司信息
      getCompanyInfo() {
        return new Promise((resolve, reject) => {
          if (!this.cpid) {
            reject(new Error('cpid不存在'));
            return;
          }
          
          getCompany(this.cpid).then(res => {
            this.company = res.data;
            resolve(res);
          }).catch(error => {
            reject(error);
          });
        });
      },
      // 退出系统
      logOut() {
        return new Promise((resolve, reject) => {
          logout(this.token).then(() => {
            this.token = ''
            this.roles = []
            this.permissions = []
            removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      }
    }
  })

export default useUserStore
